module.exports = __webpack_public_path__ + "img/nagoya_tokyuhotels.b9d1b38f.jpg";